module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/christmas_mobile-2d7baf30e0e58016b45cd1fbd0db0719.png";